import { takeEvery, put, call, select } from "redux-saga/effects"

//Account Redux states
import { CHECK_ACCOUNT, REGISTER_USER } from "./actionTypes"
import { registerUserSuccessful, registerUserFailed, checkAccountSuccessful, checkAccountFailed } from "./actions"

//Include Both Helper File with needed methods
// import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import {
  postFakeRegister,
  postJwtRegister,
} from "../../../helpers/fakebackend_helper"
import { checkAccount, getCheckTakeBack } from "../../../helpers/backend_helper"

// initialize relavant method of both Auth
// const fireBaseBackend = getFirebaseBackend()

// Is user register successfull then direct plot user in redux.
function* registerUser({ payload: { user } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      // const response = yield call(
      //   fireBaseBackend.registerUser,
      //   user.email,
      //   user.password
      // )
      // yield put(registerUserSuccessful(response))
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const response = yield call(postJwtRegister, "/post-jwt-register", user)
      yield put(registerUserSuccessful(response))
    } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
      const response = yield call(postFakeRegister, user)
      yield put(registerUserSuccessful(response))
    }
  } catch (error) {
    yield put(registerUserFailed(error))
  }
}

function* checkAccountAsync() {
  try {
    const response = yield call(checkAccount)

    const takeback_id = yield select(state => state?.TakeBacks?.items?.[0]?.id)
    if(takeback_id){
      const take_back_tasks = yield call(() => getCheckTakeBack(takeback_id))
      yield put(checkAccountSuccessful({...response, take_back_tasks }))
    }else{
      yield put(checkAccountSuccessful(response))
    }

  } catch (error) {
    yield put(checkAccountFailed(error))
  }
}

function* accountSaga() {
  yield takeEvery(REGISTER_USER, registerUser)
  yield takeEvery(CHECK_ACCOUNT, checkAccountAsync)
}

export default accountSaga
